import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { BaseText, theme } from 'aimo-ui';
import { showToast } from 'components/common/CustomToast';
import MenuItem from 'components/common/MenuItem';
import { Container } from 'components/park/styles/styles';
import HslContext from 'context/HslContext';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DateTimePicker from 'react-native-modal-datetime-picker';
import { StyledWrapper } from 'styles/ContainerStyles';
import { HslParkingStackParamList, ServicesNavProps } from 'types/navigation';
import { getLocale } from 'utils/commonUtils';
import { isAndroid, isIos } from 'utils/deviceUtils';

const HslValidFromSelection = () => {
  const { setSelections, selections } = useContext(HslContext);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const { navigate } = useNavigation<ServicesNavProps>();
  const { goBack, canGoBack } =
    useNavigation<StackNavigationProp<HslParkingStackParamList>>();

  const handleBack = () => {
    if (canGoBack()) {
      goBack();
    } else {
      navigate('hslNavigator', { screen: 'hslTicket' });
    }
  };
  const { t } = useTranslation();

  const onItemPress = (validFrom: string) => {
    if (validFrom === 'now') {
      setSelections({ ...selections, validFrom: 'Now' });
      handleBack();
      return;
    }
    setCalendarVisible(true);
  };

  const selectedDate =
    selections.validFrom !== 'Now'
      ? (selections.validFrom as Date)
      : new Date();

  const maxDate = new Date(selectedDate?.getTime() + 24 * 60 * 60 * 1000);
  const onConfirm = (newDate: Date) => {
    const isOverMaximum = newDate > maxDate;
    if (isAndroid && isOverMaximum) {
      showToast(t('error.overMaxDate'), 'info');
      setSelections({ ...selections, validFrom: maxDate });
      handleBack();
      return;
    }
    setSelections({ ...selections, validFrom: newDate });
    handleBack();
  };
  return (
    <Container testID="hsl-select-valid-from-container" mr={20} ml={20}>
      <StyledWrapper center maxWidth={250} mb={20}>
        <BaseText center>{t('hslTicket.validityInfo')}</BaseText>
      </StyledWrapper>
      <StyledWrapper>
        <StyledWrapper mb={10}>
          <MenuItem
            onPress={() => onItemPress('now')}
            menuLabel={t('hslTicket.validity.now')}
            noBorder
            testID="hsl-select-valid-from-now"
            iconName="Time-Outlined"
            background={theme.colors.gray50}
          />
        </StyledWrapper>

        <MenuItem
          onPress={() => onItemPress('select')}
          menuLabel={t('hslTicket.validity.set')}
          noBorder
          testID="hsl-select-valid-from-setValue"
          iconName="Calendar-Outlined"
          background={theme.colors.gray50}
        />
      </StyledWrapper>
      <DateTimePicker
        isVisible={calendarVisible}
        onConfirm={onConfirm}
        mode="datetime"
        date={selectedDate}
        minimumDate={selectedDate}
        maximumDate={maxDate}
        is24Hour={true}
        testID="hsl-select-valid-from-datePicker"
        locale={getLocale().toString()}
        cancelTextIOS={t('button.cancel')}
        confirmTextIOS={t('button.confirm')}
        cancelButtonTestID="hsl-valid-calendar-cancel"
        confirmButtonTestID="hsl-valid-calendar-confirm"
        onCancel={() => setCalendarVisible(false)}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /*
        // @ts-ignore */
        display={isIos ? 'inline' : 'default'}
      />
    </Container>
  );
};

export default HslValidFromSelection;
